module.exports = __webpack_public_path__ + "img/wema.d4067512.svg";